<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <p class="font">{{ $t("labels.teacher_kyc") }}</p>
    </div>
    <div class="ml-auto md:block">
      <vs-button
        color="success"
        icon="icon-search"
        @click="data_hide = !data_hide"
        icon-pack="feather"
        >Search</vs-button
      >
    </div>
    <vx-card class="mt-4" v-show="data_hide">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/4 w-full">
          <label class="vs-input--label">{{ $t("labels.gender") }}</label>
          <v-select
            v-validate="'required'"
            :placeholder="$t('labels.select_gender')"
            name="subcategory_type"
            v-model="gender"
            :success="true"
            :clearable="false"
            success-text="This field is valid"
            :options="genderArray"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full"
            label="value"
          />
        </div>
       <div class="vx-col sm:w-1/4 w-full">
          <label class="vs-input--label">{{ $t("labels.kyc_type") }}</label>
          <v-select
            v-validate="'required'"
            :placeholder="$t('labels.select_kyc_type')"
            name="subcategory_type"
            v-model="kyc_type"
            :success="true"
            :clearable="false"
            success-text="This field is valid"
            :options="KYCTypeArray"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full"
            label="value"
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <label class="vs-input--label">{{ $t("labels.kyc_status") }}</label>
          <v-select
            v-validate="'required'"
            :placeholder="$t('labels.select_kyc_status')"
            name="subcategory_type"
            v-model="kyc_status"
            :success="true"
            :clearable="false"
            success-text="This field is valid"
            :options="KYCStatusArray"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full"
            label="value"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button color="success" class="mr-3 mb-2" @click="getAllKYC()"
            >Search</vs-button
          >
          <vs-button color="danger" class="mb-2 mr-3" @click="resetForm()"
            >Reset</vs-button
          >
          <vs-button color="black" class="mb-2" @click="data_hide = !data_hide"
            >Close</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-4">
      <vs-table :max-items="perPage" stripe :data="users">
        <template slot="thead">
          <vs-th>{{ $t("labels.F_name") }}</vs-th>
          <vs-th>{{ $t("labels.l_name") }}</vs-th>
          <vs-th>{{ $t("labels.phone_no") }}</vs-th>
          <vs-th>{{ $t("labels.gender") }}</vs-th>
          <vs-th>{{ $t("labels.kyc_type") }}</vs-th>
          <vs-th>{{ $t("labels.document_front") }}</vs-th>
          <vs-th>{{ $t("labels.document_back") }}</vs-th>
          <vs-th>{{ $t("labels.kyc_status") }}</vs-th>
          <vs-th>{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].first_name">
              <p v-if="data[indextr].first_name">
                {{ data[indextr].first_name }}
              </p>
              <span v-if="!data[indextr].first_name">---</span>
            </vs-td>

            <vs-td :data="data[indextr].last_name">
              <p v-if="data[indextr].last_name">
                {{ data[indextr].last_name }}
              </p>
              <span v-if="!data[indextr].last_name">---</span>
            </vs-td>

            <vs-td :data="data[indextr].mobile">
              <p v-if="data[indextr].mobile">{{ data[indextr].mobile }}</p>
              <span v-if="!data[indextr].mobile">---</span>
            </vs-td>

            <vs-td :data="data[indextr].gender">
              <p v-if="data[indextr].gender == 'M'">{{ $t("labels.male") }}</p>
              <span v-if="data[indextr].gender == 'F'">{{
                $t("labels.female")
              }}</span>
            </vs-td>

            <vs-td :data="data[indextr].kyc_type">
              <p v-if="data[indextr].kyc_type == 'licence'">
                {{ $t("labels.licence") }}
              </p>
              <p v-if="data[indextr].kyc_type == 'passport'">
                {{ $t("labels.passport") }}
              </p>
              <p v-if="data[indextr].kyc_type == 'identity card'">
                {{ $t("labels.id_card") }}
              </p>
              <p v-if="data[indextr].kyc_type == 'residence permit'">
                {{ $t("labels.resi_permit") }}
              </p>
            </vs-td>
            <vs-td :data="data[indextr].document_front">
              <a
                :href="data[indextr].document_front"
                target="_blank"
                class="float-left mr-1"
              >
                <div class="img-container mb-4">
                  <vs-avatar
                        size="100px"
                        v-bind:src="data[indextr].document_front"
                  />
                </div>
              </a>
            </vs-td>
            <vs-td :data="data[indextr].document_back">
              <a
                :href="data[indextr].document_back"
                target="_blank"
                class="float-left mr-1"
              >
                <div class="img-container mb-4">
                  <vs-avatar
                        size="100px"
                        v-bind:src="data[indextr].document_back"
                  />
                </div>
              </a>
            </vs-td>
            <vs-td :data="data[indextr].kyc_status">
              <p v-if="data[indextr].kyc_status == 'A'" class="approved">
                {{ $t("labels.approved") }}
              </p>
              <p v-if="data[indextr].kyc_status == 'P'" class="pending">
                {{ $t("labels.pending") }}
              </p>
              <p v-if="data[indextr].kyc_status == 'R'" class="rejected">
                {{ $t("labels.rejected") }}
              </p>
              <span v-if="!data[indextr].kyc_status">---</span>
            </vs-td>

            <vs-td :data="data[indextr].email">
              <!-- <span>
                <router-link
                  :to="{
                    name: 'TeachersKYCById',
                    params: { id: data[indextr].user_id },
                  }"
                > -->
                  <vs-button
                    title="View"
                    class="m-1 float-left"
                    color="success"
                    icon="icon-eye"
                    icon-pack="feather"
                     @click.stop="viewDetails(data[indextr].user_id)"
                  ></vs-button>
                </router-link>
              </span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div class="float-right mt-5">
      <vs-pagination
        ref="paginationApplication"
        :total="totalPage"
         :max="6"
        v-model="currentPage"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect,
  },
  data: () => ({
    value: "",
    select2: "",
    data_hide: false,
    users: [],
    gender: "",
    kyc_type: "",
    kyc_status: "",
    changeID: null,
    deleteID: null,
    page: 1,
    perPage: 10,
    totalPage: 0,
    currentPage: 1,
    pageChange: false,
    genderArray: [
      {
        id: "M",
        value: "Male",
      },
      {
        id: "F",
        value: "Female",
      },
      {
        id: "O",
        value: "Other",
      },
    ],
    KYCTypeArray: [
      {
        id: "passport",
        value: "Passport",
      },
      {
        id: "residence_permit",
        value: "Residence Permit",
      },
      {
        id: "identity_card",
        value: "Identity Card",
      },
      {
        id: "licence",
        value: "Driver’s License",
      },
      // {
      //   id: "Proof of residence",
      //   value: "Proof of residence",
      // },
      // {
      //   id: "Utility Bill",
      //   value: "Utility Bill",
      // },
      // {
      //   id: "Bank Statement",
      //   value: "Bank Statement",
      // },
    ],
    KYCStatusArray: [
      {
        id: "A",
        value: "Approved",
      },
      {
        id: "R",
        value: "Rejected",
      },
      {
        id: "P",
        value: "Pending",
      },
    ],
    gender_search: null,
    status_search: null,
    type_search: null,
  }),
  watch: {
    currentPage(nv) {
      if (nv) {
        this.pageChange = true;
        // this.$route.query.page = nv;
        this.getAllKYC();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getAllKYC();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 10;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        this.getAllKYC();
      }
    },
  },
  methods: {
    getAllKYC() {
      let pageNo = this.currentPage;
      if (this.pageChange == false) {
        if (this.$route.query.page) {
          pageNo = this.$route.query.page;
        }
      }
      if (this.gender) {
        this.gender_search = this.gender.id;
      } else {
        this.gender_search = "";
      }
      if (this.kyc_type) {
        this.type_search = this.kyc_type.id;
      } else {
        this.type_search = "";
      }
      if (this.kyc_status) {
        this.status_search = this.kyc_status.id;
      } else {
        this.status_search = "";
      }
      let input = {
        type: this.type_search,
        gender: this.gender_search,
        kyc_status: this.kyc_status,
        page: this.currentPage,
        perPage: this.perPage,
      };
      axios
        .post("admin/getAllKYC", input)
        .then((response) => {
          let data = response.data.data;
          this.users = data.kyc;
          console.log(data);
          if (data.count < this.perPage) {
            this.currentPage = 1;
          } else {
            this.currentPage = parseInt(pageNo);
          }
          this.totalPage = Math.ceil(data.count / this.perPage);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    resetForm() {
      (this.gender = ""), (this.kyc_type = ""), (this.kyc_status = "");
      this.getAllKYC();
    },
    BlockUnblock(id, status) {
      this.changeID = id;
      this.sts = status;
      let text = text;
      let title_model = title_model;
      if (status) {
        text = this.$t("strings.block_user");
        title_model = this.$t("labels.block_user");
      } else {
        text = this.$t("strings.unblock_user");
        title_model = this.$t("labels.unblock_user");
      }
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: title_model,
        text: text,
        acceptText: this.$t("labels.delete_button"),
        accept: this.acceptAlert,
      });
    },
    acceptAlert() {
      let input = {
        is_active: !this.sts,
      };
      axios
        .post("user/changeStatus/" + this.changeID, input)
        .then((response) => {
          let data = response.data;
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });
          this.getAllKYC();
          this.changeID = null;
        })
        .catch((e) => {
          this.changeID = null;
          this.showError(e);
        });
    },
    DeleteAccount(id) {
      this.deleteID = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("labels.delete_user"),
        text: this.$t("strings.delete_user"),
        acceptText: this.$t("labels.delete_button"),
        accept: this.deleteUser,
      });
    },
    deleteUser() {
      let input = {
        user_id: this.deleteID,
      };
      axios
        .post("user/deleteAccount", input)
        .then((response) => {
          let data = response.data;
          this.getAllStudents();
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });

          this.deleteID = null;
        })
        .catch((e) => {
          this.deleteID = null;
          this.showError(e);
        });
    },
    clearInput() {
      let email = document.getElementById("text-box-val-email").value;
      if (email == "") {
        this.getAllKYC();
      }
      let id = document.getElementById("text-box-val-id").value;
      if (id == "") {
        this.getAllKYC();
      }
    },
    viewDetails(id) {
      this.$router.push("Teacher-KYC/view/" + id + "?page=" + this.currentPage);
    },
  },
  mounted() {
    this.getAllKYC();
  },
};
</script>

<style lang="scss" scoped>
</style>